import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getCourseProofsByOwnerOptions } from '@/module/Author/Course/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface CourseOwnerProofListProps {
  courseId: Id;
  userId: Id;
}

export function CourseOwnerProofList({ courseId, userId }: CourseOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getCourseProofsByOwnerOptions(courseId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="course"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
